import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const CaltexDatepicker = (props) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                defaultValue={""}
                onChange={props.onChange}
                value={props.value || null}
                format="DD/MM/YYYY"
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        borderBottom: "1px solid rgba(0, 0, 0, 0.23)",
                        borderRadius: "0",
                    },
                    "& .MuiOutlinedInput-input": {
                        paddingLeft: "0",
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default CaltexDatepicker;
